import cachios from 'cachios';

const API_URL = `${process.env.VUE_APP_API_URL}`;
const COMPANY_ID = 30;

function executeFilterBuilder(params = {}) {
  return cachios.request({
    params,
    method: 'GET',
    url: `${API_URL}/filter/execute/public`,
  });
}

export async function getOrganizations() {
  return executeFilterBuilder({
    name: 'ORGANIZATIONS_EXPORT',
    company_id: COMPANY_ID,
  }).then((response) => {
    return response.data;
  });
}

// export async function getOrganizationsNumberByProv() {
//   return executeFilterBuilder({
//     name: 'ORGANIZATIONS_NUMBER_BY_PROV_EXPORT',
//     company_id: COMPANY_ID,
//   }).then((response) => {
//     return response.data;
//   });
// }

export async function getOrganizationsNumberByCCAA() {
  return executeFilterBuilder({
    name: 'ORGANIZATIONS_NUMBER_BY_CCAA_EXPORT',
    company_id: COMPANY_ID,
  }).then((response) => {
    return response.data[0].data;
  });
}
